import { Country } from '~/Api/Country';

export enum ErrorCode {
	IllegalPriceTypeSelectedErrorCode = 'czech-reimbursement-calculation-illegal-price-type-selected',
	OnlyOneProductPerCountryErrorCode = 'czech-reimbursement-calculation-requires-at-most-one-product-for-each-country',
	RequiredProductSettingsMissingErrorCode = 'czech-reimbursement-calculation-required-product-settings-is-missing',
	RequiresReferenceSettingsErrorCode = 'czech-reimbursement-calculation-requires-reference-settings',
	RequiresAtLeastOneReferenceCountryProduct = 'czech-reimbursement-calculation-requires-at-least-one-reference-country-product',
	RequiresAtLeastOneProduct = 'czech-reimbursement-calculation-requires-at-least-one-product',
	CannotChangeSettingsForNonMemberProducts = 'czech-reimbursement-calculation-cannot-change-settings-for-non-member-products',
	RequiresAtLeastOneProductList = 'czech-reimbursement-calculation-requires-at-least-one-product-list',
	SettingsUnknownSavingsGroups = 'czech-reimbursement-calculation-settings-unknown-savings-groups',
	CannotChangeSettingsForNonMemberProductLists = 'czech-reimbursement-calculation-cannot-change-settings-for-non-member-product-lists',
}

export class Error {
	public constructor(
		public code: ErrorCode,
		public productId: string | null,
		public productGroupId: string | null,
		public duplicateCountries: Country[]
	) {}
}
